import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InteractiveMessage } from '../../../../../../shared/models/cerebrum-core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-buttons-chat-bubble',
  templateUrl: './buttons-chat-bubble.component.html',
  styleUrls: ['./buttons-chat-bubble.component.scss'],
})
export class ButtonsChatBubbleComponent implements OnInit {

  activeOption = false;
  @Input() content;

  @Output() sendOption: EventEmitter<any> = new EventEmitter();

  constructor(public sanitization: DomSanitizer) {}
  ngOnInit() {}

  sendOptionEmitter(option, item) {
    const message: string = (this.content.body === null && this.content.footer !== null) ? this.content.footer :
      (this.content.body !== null && this.content.footer === null) ? this.content.body :
        (this.content.body !== null && this.content.footer !== null) ? this.content.body + ' ' + this.content.footer :
          '';

    const interactiveMessage: InteractiveMessage = {
      title: 'Entity Name',
      replyMessage: message,
      postbackData: item.postbackData,
      messageDisplay: item.title,
      type: 'button',
      relatedClientMessageId: this.content.clientMessageId
    };

    this.sendOption.emit(interactiveMessage);
    this.activeOption = true;
  }
}
